import { Link } from 'react-router-dom';
import { Clinic } from '../types/api';
import { AddressDisplay } from './AddressDisplay';


interface Props {
  clinic: Clinic;
}

export default function ClinicCard({ clinic }: Props) {
  return (
    <div className="card hover:shadow-md transition-shadow">
      <div className="flex justify-between items-start">
        <div className="min-w-0 flex-1">
          <h3 className="font-bold text-navy text-lg truncate">{clinic.name}</h3>
          <div className="mt-1">
            <AddressDisplay
              addressDisplay={clinic.address_display}
              address={clinic.address}
              island={clinic.island}
              compact
            />
          </div>
        </div>
        {clinic.distance_meters != null && (
          <span className="bg-primary-50 text-primary text-xs font-semibold px-2.5 py-1 rounded-full flex-shrink-0 ml-2">
            {(clinic.distance_meters / 1000).toFixed(1)} km
          </span>
        )}
      </div>

      <div className="flex items-center gap-3 mt-3 text-sm text-gray-400">
        {clinic.phone && <span>{clinic.phone}</span>}
        {clinic.accepts_walkins && (
          <span className="text-primary font-medium">Walk-ins accepted</span>
        )}
      </div>

      <div className="mt-4 flex gap-2">
        <Link
          to={`/clinics/${clinic.slug}`}
          className="btn btn-primary btn-sm flex-1"
        >
          View Details
        </Link>
        <Link
          to={`/book/${clinic.slug}`}
          className="btn btn-outline btn-sm"
        >
          Book
        </Link>
      </div>
    </div>
  );
}
